import { render, staticRenderFns } from "./DOTSPatientOnlyDetail.vue?vue&type=template&id=25052e4d&scoped=true"
import script from "./DOTSPatientOnlyDetail.vue?vue&type=script&lang=js"
export * from "./DOTSPatientOnlyDetail.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientOnlyDetail.vue?vue&type=style&index=0&id=25052e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25052e4d",
  null
  
)

export default component.exports